/* global G */
import { curry, isObj } from 'lib/util'

const descriptor = 'model::transformer::toJSON'

/**
 * To JSON Transformer
 *
 * Transforms the incoming data into a JSON string.
 *
 * Does not validate the data! It should have been validated
 * before using the {@link isJSON} validator.
 *
 *
 * @param {string} key          the name of the attribute to store the data to
 * @param {Gaia.Model.Spec} obj the current model object composition
 * @param {Object} data         the payload data processed until now
 * @returns {Object}             the payload data
 */
const fn = (key, obj, data) => {
  console.warn(descriptor, key)

  const _data = data
  const attribute = obj[G.CHILDREN][key]
  const attributeData = attribute[G.DATA]?.value || obj[G.DATA][key]

  _data.value[key] = JSON.stringify(JSON.parse(isObj(attributeData) ? attributeData.key : attributeData))

  return _data
}

export default curry(fn)
